import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import cyan from '@material-ui/core/colors/cyan';
import lightGreen from '@material-ui/core/colors/lightGreen';
import orange from '@material-ui/core/colors/orange';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import TechnicalSkill from '../models/technical-skills';
import { SkillArea, SkillFrequency } from '../API';

interface TechnicalSkillChipsProps {
  skills: TechnicalSkill[] | undefined,
  noSkillsText?: string,
  small?: boolean,
  showFrequency: boolean,
  noContainer?: boolean,
}

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(1),
    '& > *': {
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
}));

const SKILL_AREA_FREQUENCY_COLORS = {
  [SkillArea.FRONTEND]: {
    [SkillFrequency.UNLIKELY]: cyan[50],
    [SkillFrequency.RARELY]: cyan[200],
    [SkillFrequency.OCCASIONALLY]: cyan[400],
    [SkillFrequency.FREQUENTLY]: cyan[600],
  },
  [SkillArea.BACKEND]: {
    [SkillFrequency.UNLIKELY]: lightGreen[50],
    [SkillFrequency.RARELY]: lightGreen[200],
    [SkillFrequency.OCCASIONALLY]: lightGreen[400],
    [SkillFrequency.FREQUENTLY]: lightGreen[600],
  },
  [SkillArea.MOBILE]: {
    [SkillFrequency.UNLIKELY]: orange[50],
    [SkillFrequency.RARELY]: orange[200],
    [SkillFrequency.OCCASIONALLY]: orange[400],
    [SkillFrequency.FREQUENTLY]: orange[600],
  },
} as Partial<Record<SkillArea, Record<SkillFrequency, string>>>;

export default function TechnicalSkillChips({
  skills,
  noSkillsText,
  small,
  showFrequency = false,
  noContainer,
}: TechnicalSkillChipsProps) {
  const classes = useStyles();
  if (!skills?.length) return <Typography>{noSkillsText}</Typography> ?? null;
  const chips = skills.map((skill) => (
    <Chip
      key={skill.id}
      label={skill.name}
      size={small ? 'small' : undefined}
      style={{
        background: SKILL_AREA_FREQUENCY_COLORS[skill.area]![
          showFrequency && skill.frequency ? skill.frequency : SkillFrequency.UNLIKELY
        ],
      }}
    />
  ));
  if (noContainer) return <>{chips}</>;
  return (
    <Box className={classes.container}>
      {chips}
    </Box>
  );
}
